var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionItem({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.1665 12.75L12.8332 12.75",
    stroke: "#202020",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.37484 10.4167C3.82964 10.4167 3.55705 10.4167 3.354 10.2994C3.22099 10.2226 3.11053 10.1122 3.03373 9.97917C2.9165 9.77612 2.9165 9.50353 2.9165 8.95833L2.9165 3.70833C2.9165 3.16314 2.9165 2.89054 3.03373 2.6875C3.11053 2.55448 3.22099 2.44403 3.354 2.36723C3.55705 2.25 3.82964 2.25 4.37484 2.25C4.92003 2.25 5.19263 2.25 5.39567 2.36723C5.52869 2.44403 5.63915 2.55448 5.71594 2.6875C5.83317 2.89054 5.83317 3.16314 5.83317 3.70833L5.83317 8.95833C5.83317 9.50353 5.83317 9.77612 5.71594 9.97917C5.63915 10.1122 5.52869 10.2226 5.39567 10.2994C5.19263 10.4167 4.92003 10.4167 4.37484 10.4167Z",
    stroke: "#202020"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.62484 10.4167C9.07964 10.4167 8.80705 10.4167 8.604 10.2994C8.47099 10.2226 8.36053 10.1122 8.28373 9.97917C8.1665 9.77612 8.1665 9.50353 8.1665 8.95833L8.1665 5.45833C8.1665 4.91314 8.1665 4.64054 8.28373 4.4375C8.36053 4.30448 8.47099 4.19403 8.604 4.11723C8.80705 4 9.07964 4 9.62484 4C10.17 4 10.4426 4 10.6457 4.11723C10.7787 4.19403 10.8891 4.30448 10.9659 4.4375C11.0832 4.64054 11.0832 4.91314 11.0832 5.45833L11.0832 8.95833C11.0832 9.50353 11.0832 9.77612 10.9659 9.97917C10.8891 10.1122 10.7787 10.2226 10.6457 10.2994C10.4426 10.4167 10.17 10.4167 9.62484 10.4167Z",
    stroke: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionItem);
export default __webpack_public_path__ + "static/media/actionItem.de603f053c903f8f8ce555d617793055.svg";
export { ForwardRef as ReactComponent };